import { IconButton, List, ListItem, ListItemText, ListItemAvatar } from "@mui/material";

import Site from "../models/Site";

import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import OpsAvatarComponent from "./OpsAvatarComponent";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import Badge from "../models/Badge";

interface Props {
  viewMode: boolean;
  selectedFile: string | undefined;
  onDelete: () => void;
}

export default function OpsDialogImage(props: Props) {
  return (
    <>
      <div className="mx-auto d-flex justify-content-center">
        <OpsAvatarComponent
          avatarUrl={props.selectedFile ? props.selectedFile : ""}
          forceGenericAvatar={true}
          genericAvatar={<NoPhotographyIcon sx={{ width: "4em", height: "4em" }} />}
          sx={{ width: "6.5em", height: "6.5em" }}
          customStyle={{ maxWidth: "50%", display: "flex", justifyContent: "center", margin: "auto" }}
        />
      </div>
      <List dense>
        <ListItem
          alignItems={"center"}
          secondaryAction={
            <>
              {props.selectedFile && (
                <IconButton
                  edge="end"
                  aria-label="view"
                  onClick={() => {
                    window.open(props.selectedFile, "_blank");
                  }}
                >
                  <SearchIcon />
                </IconButton>
              )}
              {!props.viewMode && props.selectedFile && (
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => {
                    props.onDelete();
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </>
          }
        >
          {props.selectedFile && (
            <ListItemText
              primary={props.selectedFile.length > 50 ? props.selectedFile.substring(0, 50).concat("...") : props.selectedFile}
            />
          )}
        </ListItem>
      </List>
    </>
  );
}
